<template>
  <vx-card title="Banners">
    <p>Aquí se pueden modificar los Banners que aparecen en el Home.</p>

    <div v-if="initProgress" style="margin-top: 1rem; width: 100%">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <div class="mt-5">
      <!-- Banners -->
      <div class="flex flex-wrap -mx-2">
        <div class="w-1/2 px-2" v-for="(banner, index) in content.bannersDesktop" :key="index">
          <div>
            <!-- Image Container -->
            <div class="img-container flex items-center justify-center">
              <img :src="banner.image" alt="img" class="responsive">

            </div>
            <!-- Image upload Buttons -->
            <div class="modify-img flex justify-between mt-5">
              <input type="file" class="hidden" :id="`banner${index}`" @change="updateBanner($event,banner,index)"
                     accept="image/*">
              <span style="cursor: pointer" class="ml-2" type="flat"
                    @click="changeBanner(`banner${index}`)">Cambiar
                                </span>
              <span style="cursor: pointer" class="mr-2" type="flat" color="#999"
                    @click="deleteImage(index)">Eliminar</span>
            </div>
          </div>
          <div class="mt-5">
            <vs-input @blur="banner.path= trimString(banner.path)" label="Path"
                      v-model="banner.path"
                      class="mt-5 w-full" name="path"
                      v-validate="'required'"/>
          </div>
          <hr class="mt-5 mb-5">
        </div>
      </div>

      <!--Add image-->
      <vs-button style="width: 100%" @click="addBanner">Agregar banner (820x660)</vs-button>
      <!--End-->

      <div class="flex mt-6 flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
        <div v-if="progress" style="margin-top: 1rem; width: 100%">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </div>

    </div>
  </vx-card>
</template>

<script>
import trimString from '../mixins/trimString'

import { db, auth, FieldValue } from '@/firebase/firebaseConfig'
import { uploadToCloudflare } from '@/services/cloudflareImages'

export default {
  name: 'BannersDesktop',
  mixins: [
    trimString
  ],
  data () {
    return {
      content: {
        bannersDesktop: []
      },
      progress: false,
      initProgress: false
    }
  },
  /**
   * Get data on firestore
   * @returns {Promise<void>}
   */
  async created () {
    try {
      this.initProgress = true
      const querySnapshot = await db.collection('content').get()
      querySnapshot.forEach((doc) => {
        this.content.id = doc.id
        this.content.bannersDesktop = doc.data().bannersDesktop ? doc.data().bannersDesktop : []
      })
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  computed: {
    isFormValid () {
      return !this.errors.any()
    }
  },
  methods: {
    /**
     * Save data on firestore
     * @returns {Promise<void>}
     */
    async submitData () {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          this.progress = true

          // Content
          let contentRef = db.collection('content').doc(this.content.id)

          //Clone to remove the id
          let cloneContent = Object.assign({}, this.content)
          delete cloneContent.id

          await contentRef.update({
            ...cloneContent,
            uid: auth.currentUser.uid,
            updatedAt: FieldValue.serverTimestamp()
          })

          this.$vs.notify({
            color: 'success',
            title: 'Banners',
            text: 'Banners modificados correctamente.'
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.progress = false
      }
    },
    variantForIndex (index) {
      return index <= 2 ? '820x660' : '668x378'
    },
    async updateBanner (input, banner, index) {
      this.progress = true
      try {
        if (input.target.files && input.target.files[0]) {
          banner.image = await uploadToCloudflare(input.target.files[0], this.variantForIndex(index))
        }
      } catch (e) {
        console.error('Error subiendo banner:', e)
        this.$vs.notify({
          color: 'danger',
          title: 'Error al subir imagen',
          text: e.message || 'No se pudo subir la imagen. Revisa la consola.'
        })
      } finally {
        this.progress = false
      }
    },
    deleteImage (index) {
      this.content.bannersDesktop.splice(index, 1)
    },
    changeBanner (id) {
      const banner = document.getElementById(id)
      banner.click()
    },
    addBanner () {
      const index = this.content.bannersDesktop.length
      const size = this.variantForIndex(index)
      let obj = {
        path: '/',
        image: `https://via.placeholder.com/${size}`
      }
      this.content.bannersDesktop.push(obj)
    }
  }
}
</script>
